import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../sidebar/sidebar";
import ReactPaginate from "react-paginate";
import TopBar from "../../topbar/TopBar";
import search from "../../../assets/svg/search.svg";
import df from "../../../assets/svg/df.svg";
import cus from "../../../assets/svg/cus.svg";
import filt from "../../../assets/svg/filt.svg";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import pn from "../../../assets/svg/pn.svg";
import { get } from "../../../services/apiService";
import { Container, Row, Col } from "react-bootstrap";
import {
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { ReactComponent as EditRow } from "../../../assets/svg/edit.svg";
import { ReactComponent as DeleteRow } from "../../../assets/svg/delete-icon.svg";
import PurposeVisitCreateModal from "../../modal-dialog/purpose-visit-create-modal";
import { getDeletePOVApi } from "../../modal-dialog/setup-api";

const Purposeofvisit = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [showInput, setShowInput] = useState(false);
  const [term, setTerm] = useState("");
  const navigate = useNavigate();

  const [visits, setVisits] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);

  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [povId, setPOVId] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % visits.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);

  }, []);



  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  useEffect(() => {
    getListData(term);
  }, [itemOffset, itemsPerPage, sortByField, sortBy, term]);

  const getListData = async (term) => {
    try {
      const response = await get(apiUrl + "visit?limit=" + itemsPerPage + "&skip=" + (itemOffset) * itemsPerPage + "&search=" + encodeURIComponent(term) + "&sortByField=" + sortByField + "&sortBy=" + sortBy)
        .then(async (response) => {
          if (response.data.status === true) {
            setTotalCount(response.data.totalCount ?? 0);
            setPageCount(response.data.totalPages);
            setVisits(response.data.Purpose_of_visit);
            console.log("Page count", pageCount);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          }
        });
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setDeleteId(null);
      setIsOpenDelete(false); // Close the alert
    }
  };

  const deleteModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };
  const [deleteId, setDeleteId] = useState(null);
  const deleteDialog = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  }
  const deleteApi = async () => {
    if (deleteId != null) {
      const response = await getDeletePOVApi(deleteId);

      if (response?.status === 200) {
        if (response.data.status === true) {
          setDeleteId(null);
          setIsOpenDelete(false);
          getListData("");
        }
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
      }

    }
  };
  const onSuccess = async (response) => {
    setShowCreateModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term)
  }
  return (
    <div style={{ fontFamily: "Epilogue" }}>
      {showCreateModal === true && (<PurposeVisitCreateModal povId={povId} onSuccess={onSuccess} onCancel={() => setShowCreateModal(false)} />)}
      <div>
        <TopBar />
      </div>
      <div style={{ display: "flex" }}>
        <div>
          <Sidebar activeMenu={"Purpose of Visit"} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "24px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Row className="my-4 align-items-center">
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>

            <Col >
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 13,
                  color: "#8790A1",
                  whiteSpace: "nowrap", // keep text on a single line
                }}
              >
                Set up your organization with these master settings and manage them seamlessly from here.
              </div>
            </Col>

            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
            }}
          >
            <div style={{ fontWeight: "700", fontSize: "20px", color: "172B4D" }}>Purpose of Visit ({totalCount})</div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "max-content",
                }}
              >
                {showInput ? (
                  <div className="input-group rounded-pill me-2" style={{ width: "250px", flexShrink: 0 }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      style={{
                        boxShadow: "none",
                        outline: "none",
                        border: "1px solid #dcdfe4",
                      }}
                      onChange={(e) => setTerm(e.target.value)}
                      value={term}
                    />
                    <button className="btn btn-outline-secondary" style={{ borderColor: "#dcdfe4" }} onClick={() => setShowInput(false)}>
                      <img src={search} alt="Search Icon" />
                    </button>
                  </div>
                ) : (
                  <button className="btn rounded-3 me-2" style={{ borderColor: "#dcdfe4", flexShrink: 0 }} onClick={() => setShowInput(true)}>
                    <img src={search} alt="Search Icon" />
                  </button>
                )}

                {/* Sort */}
                <button className="btn rounded-3 me-2" style={{ borderColor: "#dcdfe4", flexShrink: 0 }}>
                  <img src={df} />
                  <select
                    style={{ outline: "none", border: "none", fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "600" }}
                    onChange={(e) => {
                      const [field, order] = e.target.value.split(" ");
                      setSortByField(field);
                      setSortBy(order);
                    }}
                  >
                    <option value="" style={{ fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "500" }}>Default (data created)</option>
                    <option value="name asc" style={{ fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "500" }}>Name (Asc)</option>
                    <option value="name desc" style={{ fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "500" }}>Name (Desc)</option>
                    <option value="created_at asc" style={{ fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "500" }}>Date (Oldest)</option>
                    <option value="created_at desc" style={{ fontFamily: 'Epilogue', fontSize: "13px", fontWeight: "500" }}>Date (Newest)</option>
                  </select>
                </button>

                {/* Customize & Filter */}

                <button
                  className="btn rounded-3"
                  style={{
                    borderColor: "#dcdfe4",
                    flexShrink: 0,
                    display: "none",
                  }}
                >
                  <img src={filt} alt="Filter Icon" /> Filter
                </button>

                <button
                  onClick={() => {
                    setPOVId(null)
                    setShowCreateModal(true)
                  }}
                  style={{
                    borderRadius: "12px",
                    marginLeft: "6px",
                    padding: "8px 20px",
                    backgroundColor: "#2C8C53",
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#FFFFFF",
                    border: "none",
                  }}
                >
                  + Add
                </button>
              </div>
            </div>
          </div>

          <Col sm={12} lg={12} className="mt-3">

            <div className="item-list-header" style={{ flex: '12', }}>

              <span className="item-list-header-txt style-justify-start" style={{ flex: '1' }}>S.No</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '3' }}>Code</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '4' }}>Name</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '2' }}>Duration</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '6' }}>Description</span>


            </div>
            <div>
              {visits.map((visit, index) => (
                <div key={'table-list' + index} style={{
                  position: "relative", cursor: 'pointer',
                  backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                }} onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}>

                  <div className="item-list-row" style={{ flex: '12', }}>
                    <span className="list-row-txtSNo" style={{
                      flex: '1', display: 'flex', alignItems: 'center',        // <-- this centers the text vertically
                      gap: '0px',
                    }}>
                      <div
                        style={{
                          height: '100%',
                          width: '3px',
                          backgroundColor: hoveredIndex === index ? '#2C8C53' : 'transparent',
                          marginRight: '8px',
                        }}
                      />
                      {index + 1 + (itemOffset === -1 ? itemOffset + 1 : itemOffset) * itemsPerPage}
                    </span>
                    <span className="list-row-txt1" title={visit.code} style={{ flex: '3' }}>{visit.code ?? '-'}</span>
                    <span className="list-row-txt1" title={visit.name} style={{ flex: '4' }}> {visit.name ?? '-'}</span>
                    <span className="list-row-txt1" style={{ flex: '2' }}> {visit.duration ?? '-'}</span>
                    <span className="list-row-txt1" style={{ flex: '6' }}> {visit.description ?? '-'}</span>
                  </div>
                  {hoveredIndex === index && (<div
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "1px", transform: 'translate(-50%, -50%)'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: "start", alignItems: "center", }}>
                      <div onClick={() => {
                        setPOVId(visit.id)
                        setShowCreateModal(true)
                      }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '0.6px solid #E5E5E5', cursor: "pointer", width: '32px', height: '32px', borderRadius: '100px', background: '#FFFFFF', }}><EditRow /> </div> <span style={{ marginLeft: '16px' }}></span>
                      <div onClick={() => {

                        deleteDialog(visit.id);

                      }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', border: '0.6px solid #E5E5E5', cursor: "pointer", height: '32px', borderRadius: '100px', background: '#FFFFFF', }}><DeleteRow /> </div>
                    </div>
                  </div>)}
                </div>))}
            </div>

          </Col>
          <Row style={{ marginTop: "14px", alignItems: "center" }}>
            <Col>
              <div className="d-flex align-items-center justify-content-start mx-3">
                <span
                  style={{
                    fontFamily: "Epilogue",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#212129",
                  }}
                >
                  Records per page :
                </span>
                <select
                  className="select3"
                  id="perpage"
                  value={itemsPerPage}
                  onChange={(event) => {
                    setItemsPerPage(event.target.value);
                  }}
                  style={{
                    cursor: "pointer",
                    fontFamily: "Epilogue",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "18.9px",
                    color: "#212129",
                    width: "56px",
                    height: "24px",
                    borderRadius: "10px",
                    border: "0.7px solid #E5E5E5",
                    padding: "0 4px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </Col>
            <Col>
              <div className="d-flex justify-content-end">
                <ReactPaginate
                  previousLabel={<img src={lar} className="ar3" alt="previous" />}
                  nextLabel={<img src={rar} className="ar3" alt="next" />}
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {isOpenDelete && (
        <div style={deleteModalStyle.overlay} backdrop="static">
          <div ref={alertRef} style={deleteModalStyle.modal}>
            <div style={{ color: '#ffffff' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                <div style={{ fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }}>Delete </div>
                <div style={{ marginTop: '8px', fontSize: "16px", fontWeight: "400", color: '#1E1E1E' }}>You won’t able to access your record after deleting. Are you sure want to delete?</div>

                <div style={{ flex: 12, marginTop: '8px', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start', }}>
                  <div onClick={() => { setIsOpenDelete(false); }} style={{ cursor: 'pointer', width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", border: "1px solid #E5E5E5", }}>
                    <div style={{ fontSize: "16px", fontWeight: "500", color: '#1E1E1E' }}>Cancel</div>
                  </div>
                  <div onClick={() => {
                    deleteApi();
                  }} style={{ cursor: 'pointer', width: '158px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '8px', display: 'flex', flex: 6, justifyContent: "center", alignItems: "center", background: "#FF4444", }}>
                    <div style={{ fontSize: "16px", fontWeight: "500", color: '#FFFFFF' }}>Delete</div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Purposeofvisit;
